import { Button, Group } from '@mantine/core';
import { IconCloudUpload, IconDownload, IconTrash } from '@tabler/icons-react';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import classes from './SelectionHeaderActions.module.css';

type Props = {
  selectedCount: number;
  onDeleteSelected: () => void;
  onDownloadSelected: () => void;
  onUploadToSharepoint?: () => void;
  onCancel: () => void;
  isDownloading: boolean;
  isUploadingToSharepoint?: boolean;
  downloadDisabled?: boolean;
  showSharepointUpload?: boolean;
};

export default function SelectionHeaderActions({
  selectedCount,
  onDeleteSelected,
  onDownloadSelected,
  onUploadToSharepoint,
  onCancel,
  isDownloading,
  isUploadingToSharepoint = false,
  downloadDisabled = false,
  showSharepointUpload = false,
}: Props) {
  const hasSelection = selectedCount > 0;

  return (
    <Group gap="xxs" wrap="nowrap">
      <Button
        {...pillProps}
        variant="delete-pill"
        rightSection={<IconTrash size={16} />}
        disabled={!hasSelection || isUploadingToSharepoint}
        onClick={onDeleteSelected}
      >
        Delete selected
      </Button>
      <Button
        {...pillProps}
        variant="download-pill"
        rightSection={<IconDownload size={16} />}
        loading={isDownloading}
        disabled={!hasSelection || downloadDisabled || isUploadingToSharepoint}
        onClick={onDownloadSelected}
      >
        Download selected
      </Button>
      {showSharepointUpload && (
        <Button
          {...pillProps}
          variant="sharepoint-upload-pill"
          rightSection={<IconCloudUpload size={16} />}
          loading={isUploadingToSharepoint}
          disabled={!hasSelection}
          onClick={onUploadToSharepoint}
        >
          Upload to SharePoint
        </Button>
      )}
      <Button
        {...pillProps}
        variant="cancel-pill"
        disabled={isUploadingToSharepoint}
        onClick={onCancel}
      >
        Cancel
      </Button>
    </Group>
  );
}

const pillProps = {
  size: 'xs',
  h: 24,
  px: 'xxs',
  fw: FONT_WEIGHTS.semibold,
  classNames: { root: classes.pill, section: classes.section },
} as const;
